(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gap-vip-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var slider = $('.banner-slider');
  
  slider.slick({
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    fade: false,
    cssEase: 'ease-in-out',
    autoplay: slider.data('autoplay'),
    autoplaySpeed: slider.data('autoplay-speed'),
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: false
        }
      }
    ]
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-feed"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Video controls functionality
  const videos = document.querySelectorAll('.instagram-video');
  
  videos.forEach(video => {
    const container = video.closest('.video-container');
    const soundToggle = container.querySelector('.sound-toggle');
    const playPause = container.querySelector('.play-pause');
    const soundIconMuted = container.querySelector('.sound-icon.muted');
    const soundIconUnmuted = container.querySelector('.sound-icon.unmuted');
    const playIcon = container.querySelector('.play-icon');
    const pauseIcon = container.querySelector('.pause-icon');
    
    // Initialize play/pause icon based on video state
    function updatePlayPauseIcon() {
      if (playIcon && pauseIcon) {
        if (video.paused) {
          playIcon.style.display = 'block';
          pauseIcon.style.display = 'none';
        } else {
          playIcon.style.display = 'none';
          pauseIcon.style.display = 'block';
        }
      }
    }
    
    // Set initial icon state
    updatePlayPauseIcon();
    
    // Sound toggle
    if (soundToggle) {
      soundToggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (video.muted) {
          video.muted = false;
          soundIconMuted.style.display = 'none';
          soundIconUnmuted.style.display = 'block';
        } else {
          video.muted = true;
          soundIconMuted.style.display = 'block';
          soundIconUnmuted.style.display = 'none';
        }
        return false;
      });
    }
    
    // Play/Pause toggle
    if (playPause) {
      playPause.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
        updatePlayPauseIcon();
        return false;
      });
    }
    
    // Update play/pause icon when video state changes
    video.addEventListener('play', updatePlayPauseIcon);
    video.addEventListener('pause', updatePlayPauseIcon);
    video.addEventListener('ended', updatePlayPauseIcon);
  });
});

  } catch(e) { console.error(e); }
})();
})();
